export default function untagify(str, newLineSymbol = '\n') {
  const parser = new DOMParser();

  const { body } = parser.parseFromString(str, 'text/html');
  const elements = [...body.querySelectorAll('*')];

  return elements.length > 0 ? elements.map((p) => p.innerHTML).join(newLineSymbol) : body.innerHTML;
}
